<template>
  <div>
    <PageAllow
      controller="Requisitions"
      :action="isNew ? 'add' : isView ? 'view' : isReturn ? 'getReturnableList' : mode"
    />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color pa-4">
      <ValidationObserver ref="observer">
        <v-expansion-panels v-model="panels" multiple accordion>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-card-title class="ms-n4 py-0">
                {{
                  $t((isNew || isReturn) ? "CRUD.newInfo" : "CRUD.info", [
                    isReturn ? $t("Requisition.return") :
                    requisitionType == 1
                      ? $t("Requisition.RegularRequisition")
                      : requisitionType == 2
                      ? $t("Requisition.PremuimRequisition")
                      : $t("Requisition.ObjectName"),
                  ])
                }}
                <v-chip
                  v-if="requisition.cancel_flg"
                  small
                  label
                  outlined
                  class="ms-4 mt-1"
                  color="danger"
                >
                  {{ $t("CRUD.cancelled") }}
                </v-chip>
                <v-chip
                  v-if="!isNew && !isReturn"
                  small
                  label
                  class="ms-4 mt-1"
                  :color="requisition.status | requisitionStatusColor"
                  :text-color="requisition.status | requisitionStatusTextColor"
                  >{{ requisition.status | requisitionStatusText }}
                </v-chip>
                <v-spacer />
                <v-sheet
                  class="pt-1 transparent-background-color d-inline-block"
                >
                  <v-btn
                    v-if="
                      isNew &&
                      $permission.permissionAllow('Requisitions', 'add')
                    "
                    small
                    dark
                    color="primary"
                    class="px-2 me-2 mb-1"
                    @click.stop="doSubmit()"
                  >
                    <v-icon x-small class="pe-1">fa-save</v-icon>
                    {{ $t("Requisition.actions.submitRequisition") }}
                  </v-btn>
                  <v-btn
                    v-if="
                      mode == 'edit' &&
                      $permission.permissionAllow('Requisitions', 'edit')
                    "
                    small
                    dark
                    color="primary"
                    class="px-2 me-2 mb-1"
                    @click.stop="doSubmit()"
                  >
                    <v-icon x-small class="pe-1">fa-save</v-icon>
                    {{ $t("Requisition.actions.editRequisitionSubmit") }}
                  </v-btn>
                  <v-btn
                    v-if="
                      mode == 'return' &&
                      $permission.permissionAllow('Requisitions', 'returnSave')
                    "
                    small
                    dark
                    color="primary"
                    class="px-2 me-2 mb-1"
                    @click.stop="doSubmit()"
                  >
                    <v-icon x-small class="pe-1">fa-save</v-icon>
                    {{ $t("Requisition.actions.returnRequisitionSubmit") }}
                  </v-btn>
                </v-sheet>
                <RequisitionActions
                  v-if="isView"
                  :requisition="requisition"
                  @edit="mode = 'edit'"
                  @return="mode = 'return'"
                  :showLogistic="
                    $permission.permissionAllow('Requisitions', 'editLogistics')
                  "
                  :showEdit="requisition.actions && requisition.actions.edit"
                  :showReturn="requisition.actions && requisition.actions.return"
                  detail-mode
                  showExport
                />
              </v-card-title>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <v-divider />
              <v-row no-gutters class="mt-4 table-style">
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text" v-if="isReturn">
                      {{ $t("Requisition.Fields.return_requisition_code")}}{{ $t("Global.colon") }}
                    </span>
                    <span class="secondary--text" v-else>
                      {{ $t("Requisition.Fields.requisition_code")}}{{ $t("Global.colon") }}
                    </span>
                    {{ requisition.requisition_code }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="!isNew && !isReturn">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Requisition.Fields.applicant_name")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ requisition.applier_name }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="!isNew && !isReturn">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Requisition.Fields.created_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ requisition.created | formatTime }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="!isNew && !isReturn">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Requisition.DetailFields.operater")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ requisition.operater_name }}
                  </v-card>
                </v-col>
                <!-- 调出仓库 -->
                <v-col cols="12" md="6" v-if="isNew">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Requisition.stockOutSearcher") }}
                      {{ $t("Global.colon") }}
                    </span>
                    <SearcherStock
                      v-model="stockOutSelected"
                      :label="$t('Requisition.stockOutSearcher')"
                      noLabel
                      single-line
                      dense
                      hide-details
                      class="d-inline mt-0 mb-n1"
                      :disabledItems="stockOutDisabledArr"
                      :stock-types="[0]"
                    />
                  </v-card>
                </v-col>
                <!-- 调入仓库 -->
                <v-col cols="12" md="6" v-if="isNew">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Requisition.stockInSearcher") }}
                      {{ $t("Global.colon") }}
                    </span>
                    <SearcherStock
                      v-model="stockInSelected"
                      :label="$t('Requisition.stockInSearcher')"
                      noLabel
                      single-line
                      dense
                      hide-details
                      class="d-inline mt-0 mb-n1"
                      :disabledItems="stockInDisabledArr"
                      :stock-types="[0]"
                    />
                  </v-card>
                </v-col>
                <v-col cols="12" :md="isNew ? '6' : '4'">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <!-- 执行人 -->
                    <span class="secondary--text">
                      {{ $t("Requisition.DetailFields.executor")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherAccountUser
                      v-if="savable"
                      v-model="executeUserSelected"
                      :type="[1, 2]"
                      noLabel
                      single-line
                      dense
                      hide-details
                      class="d-inline mt-0 mb-n1"
                      unclearable
                    />
                    <span v-else>
                      {{
                        requisition && requisition.from_stock
                          ? requisition.from_stock.name
                          : ""
                      }}
                    </span>
                  </v-card>
                </v-col>
                <v-col cols="12" :md="isNew ? '6' : '4'">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Requisition.DetailFields.actual_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherDatetime
                      v-if="savable"
                      class="my-n2"
                      v-model="requisition.actual_date"
                      type="datetime"
                      single-line
                      dense
                      hide-details
                    >
                    </SearcherDatetime>
                    <span v-else>
                      {{ requisition.actual_date | formatTime }}
                    </span>

                    <!-- 实际发生日期 -->
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="!isNew && !isReturn">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Requisition.DetailFields.stock_out_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{
                      requisition && requisition.from_stock_order
                        ? $datetimeUtils.formatTime(
                            requisition.from_stock_order.finish_time
                          )
                        : ""
                    }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="8" v-if="!isNew && !isReturn">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{
                        $t(
                          "Requisition.DetailFields.stock_requisition_in_name"
                        )
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{
                      requisition && requisition.to_stock
                        ? requisition.to_stock.name
                        : ""
                    }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="!isNew && !isReturn">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Requisition.DetailFields.stock_in_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{
                      requisition && requisition.to_stock_order
                        ? $datetimeUtils.formatTime(
                            requisition.to_stock_order.finish_time
                          )
                        : ""
                    }}
                  </v-card>
                </v-col>
                <v-col cols="12" :md="isNew ? '12' : '4'" v-if="!isReturn">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Requisition.Fields.type")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span v-if="requisition.type">
                      {{ requisition.type | requisitionTypesText }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 溢价模式 -->
                <v-col cols="12" md="12" v-if="savable && requisitionType == 2">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Requisition.DetailFields.premuim_model")
                      }}{{ $t("Global.colon") }}
                      <Required :show="savable" :mode="mode" />
                    </span>
                    <v-autocomplete
                      class="d-inline mt-0"
                      v-model="requisition.bargaining_type"
                      single-line
                      dense
                      hide-details
                      :items="premiumModels"
                      item-text="text"
                      item-value="value"
                      style="max-width: 280px"
                    >
                    </v-autocomplete>
                    <ValidationProvider
                      v-if="requisition.bargaining_type == 2"
                      v-slot="{ errors }"
                      :name="$t('Requisition.DetailFields.up_precent')"
                      rules="required"
                      class="mt-n6 ml-3 mb-n3"
                    >
                      <v-text-field
                        single-line
                        dense
                        v-model="requisition.cost_float_rate"
                        type="number"
                        min="0"
                        @blur="
                          requisition.cost_float_rate =
                            $numberFormatter.formatTwoDot(
                              requisition.cost_float_rate
                            )
                        "
                        :suffix="$t('Global.rate')"
                        class="d-inline mb-n1 ml-3"
                        style="max-width: 180px"
                        :error-messages="errors"
                      />
                    </ValidationProvider>
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  v-if="
                    isView &&
                    requisitionType == 2 &&
                    requisition.bargaining_type == 2
                  "
                >
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Requisition.DetailFields.up_stock_batch_cost")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ requisition.cost_float_rate | formatTwoDot }}
                    {{ $t("Global.rate") }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="12">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Requisition.Fields.memo")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <v-text-field
                      v-if="savable"
                      v-model="requisition.memo"
                      single-line
                      dense
                      hide-details
                      class="d-inline mt-0 mb-n1"
                    />
                    <span v-else>
                      {{ requisition.memo }}
                    </span>
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  md="4"
                  v-if="
                    isView &&
                    (requisition.status == 1 || requisition.status == 2) &&
                    settings &&
                    settings.requisition_express_price == 1
                  "
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.express_price")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <v-text-field
                      v-if="edit_express_price"
                      v-model="requisition.express_price"
                      :placeholder="
                        String(
                          $numberFormatter.formatTwoDot(
                            requisition.express_price,
                            2
                          )
                        )
                      "
                      single-line
                      dense
                      type="number"
                      min="0"
                      :prefix="$t('Global.money')"
                      @blur="
                        requisition.express_price =
                          requisition.express_price == ''
                            ? requisition.express_price
                            : $numberFormatter.formatMoneyFloor(
                                requisition.express_price
                              )
                      "
                      @input="Number(requisition.express_price)"
                      hide-details
                      class="d-inline mt-0 mb-n1"
                    />
                    <span v-else>
                      {{ $t("Global.money") }}
                      {{ requisition.express_price | formatMoneyFloor }}
                    </span>
                    <v-btn
                      v-if="!edit_express_price"
                      small
                      dark
                      text
                      color="action"
                      class="mb-n2"
                      @click.stop="edit_express_price = true"
                    >
                      <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
                      {{ $t("Order.actions.editExpressPrice") }}
                    </v-btn>
                    <v-btn
                      v-if="edit_express_price"
                      small
                      dark
                      text
                      color="action"
                      class="mb-n2"
                      @click.stop="saveExpressPrice()"
                    >
                      <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
                      {{ $t("CRUD.save") }}
                    </v-btn>
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  md="4"
                  v-else-if="
                    !isView &&
                    (isNew || isReturn || requisition.status == 1) &&
                    settings &&
                    settings.requisition_express_price == 1
                  "
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.express_price")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <v-text-field
                      v-model="requisition.express_price"
                      :placeholder="
                        String(
                          $numberFormatter.formatTwoDot(
                            requisition.express_price,
                            2
                          )
                        )
                      "
                      single-line
                      dense
                      type="number"
                      min="0"
                      :prefix="$t('Global.money')"
                      @blur="
                        requisition.express_price =
                          requisition.express_price == ''
                            ? requisition.express_price
                            : $numberFormatter.formatMoneyFloor(
                                requisition.express_price
                              )
                      "
                      @input="Number(requisition.express_price)"
                      hide-details
                      class="d-inline mt-0 mb-n1"
                    />
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  md="4"
                  v-else-if="
                    settings && settings.requisition_express_price == 1
                  "
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.express_price")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ $t("Global.money") }}
                      {{ requisition.express_price | formatMoneyFloor }}
                    </span>
                  </v-card>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel v-if="!isNew && !isReturn">
            <v-expansion-panel-header class="py-0">
              <v-tabs v-model="tab" background-color="transparent">
                <v-tab
                  @click.stop="
                    tab = 0;
                    panels.find((p) => p == 1) ? null : panels.push(1);
                  "
                >
                  {{ $t("Requisition.actions.activities") }}
                </v-tab>
                <v-tab
                  @click.stop="
                    tab = 1;
                    panels.find((p) => p == 1) ? null : panels.push(1);
                  "
                >
                  {{ $t("Requisition.actions.relations") }}
                </v-tab>
              </v-tabs>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-card flat>
                    <v-data-table
                      :headers="activitiesHeaders"
                      :items="requisition_activities"
                      class="elevation-0"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:item.created="{ item }">
                        <span class="text-no-wrap">
                          {{ item.created | formatTime }}
                        </span>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card flat>
                    <v-data-table
                      :headers="relationsHeaders"
                      :items="relations"
                      class="elevation-0"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:item.created="{ item }">
                        <span class="text-no-wrap">
                          {{ item.created | formatTime }}
                        </span>
                      </template>
                      <template v-slot:item.status="{ item }">
                        <v-chip
                          small
                          label
                          :color="item.status | stockOrderINStatusColor"
                          :text-color="
                            item.status | stockOrderINStatusTextColor
                          "
                          v-if="item.controller == 'StockIns'"
                        >
                          {{ item.status | stockOrderINStatusText }}
                        </v-chip>
                        <v-chip
                          small
                          label
                          :color="item.status | stockOrderOUTStatusColor"
                          :text-color="
                            item.status | stockOrderOUTStatusTextColor
                          "
                          v-if="item.controller == 'StockOuts'"
                        >
                          {{ item.status | stockOrderOUTStatusText }}
                        </v-chip>
                        <v-chip
                          small
                          label
                          :color="item.status | requisitionStatusColor"
                          :text-color="item.status | requisitionStatusTextColor"
                          v-if="item.controller == 'Requisitions'"
                        >
                          {{ item.status | requisitionStatusText }}
                        </v-chip>
                        <v-chip
                          small
                          label
                          :color="item.status | billFlgsColor"
                          :text-color="item.status | billFlgsTextColor"
                          v-else-if="item.controller == 'Receipt'"
                        >
                          {{ item.status | billFlgsText }}
                        </v-chip>
                      </template>
                      <template v-slot:item.identify_code="{ item }">
                        <span class="text-no-wrap">
                          <a
                            v-if="item.controller == 'StockIns'"
                            @click="$router.push('/stock-orders-in/' + item.id)"
                          >
                            {{ item.identify_code }}
                          </a>
                          <a
                            v-else-if="item.controller == 'StockOuts'"
                            @click="
                              $router.push('/stock-orders-out/' + item.id)
                            "
                          >
                            {{ item.identify_code }}
                          </a>
                           <a
                            v-else-if="item.controller == 'Receipt'"
                            @click="$router.push('/receipts/' + item.id)"
                           >
                            {{ item.identify_code }}
                          </a>
                          <span v-else-if="item.controller == 'Requisitions'">
                            <a
                              @click="
                                $router.replace('/requisitions/' + item.id);
                                $router.go()
                              "
                             >
                            {{ item.identify_code }}
                            </a>
                            <br />
                            （{{ $t("Requisition.Fields.return_requisition_code") }}）
                          </span>
                        </span>
                      </template>
                      <template v-slot:item.creater_name="{ item }">
                        <span v-if="item.controller == 'Requisitions'">
                          {{ item.operater_name }}
                        </span>
                        <span v-else>
                          {{ item.creater_name }}
                        </span>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-data-table
          id="requisition_details_table"
          :headers="detailsHeaders"
          :items="requisition_details"
          :search="filter"
          disable-sort
          class="elevation-2 px-4 mt-4"
          disable-pagination
          hide-default-footer
          :no-data-text="$t('Requisition.DetailNoData')"
        >
          <template v-slot:top>
            <v-toolbar flat class="transparent-background-color">
              <v-toolbar-title class="ms-n2">
                {{ $t("CRUD.details", [$t("Requisition.ObjectName")]) }}
              </v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-toolbar
              flat
              class="transparent-background-color"
              align-self="center"
            >
              <v-row no-gutters class="me-n3">
                <span class="caption secondary--text pt-2">
                  {{
                    $t(
                      "$vuetify.dataFooter.pageText",
                      requisition_details
                        ? [
                            1,
                            requisition_details.length,
                            requisition_details.length,
                          ]
                        : [0, 0, 0]
                    )
                  }}
                </span>
                <v-row no-gutters>
                  <v-spacer />
                  <v-col cols="12" sm="9" md="8">
                    <v-text-field
                      v-model="filter"
                      clearable
                      hide-details
                      :label="$t('Search.filter')"
                    />
                  </v-col>
                </v-row>
              </v-row>
            </v-toolbar>
          </template>
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <!-- 添加新商品 -->
          <template v-slot:body.prepend>
            <tr v-if="savable && !isReturn && requisition.type != 3" class="d-table-row">
              <td :colspan="detailsHeaders.length">
                <v-row no-gutters align="center" class="text-no-wrap d-flex">
                  <span class="secondary--text">
                    <a
                      @click="requisitionMaterialDialog = true"
                      style="text-decoration: underline"
                    >
                      {{ $t("CRUD.newInfo", [$t("Material.ObjectName")]) }}</a
                    >
                    {{ $t("Global.colon") }}
                  </span>
                  <keep-alive>
                    <v-autocomplete
                      color="primary"
                      hide-no-data
                      v-model="addMaterial"
                      :items="materialItems"
                      :loading="materialLoading"
                      :search-input.sync="materialSearch"
                      item-text="Description"
                      item-value="id"
                      item-disabled="disabled"
                      return-object
                      singleLine
                      dense
                      hide-details
                    ></v-autocomplete>
                  </keep-alive>
                </v-row>
              </td>
            </tr>
            <!-- 合计 -->
            <tr no-gutters class="d-none d-sm-table-row">
              <td class="secondary--text" colspan="3">
                {{ $t("Requisition.DetailFields.count_num") }}
              </td>
              <td></td>
              <td v-if="savable && isReturn"></td>
              <td class="align-end text-right">
                 {{ order_num_count | formatTwoDot }}
              </td>
              <td v-if="isView" class="align-end text-right">
                {{ requisition_num_count | formatTwoDot }}
              </td>
              <td v-if="isShowUnitPrice"></td>
              <td v-if="isView" class="align-end text-right">
                <span>
                  {{ $t("Global.money") }}{{ requisition_out_average_price | formatTwoDot }}
                </span>
              </td>
              <td v-if="isView" class="align-end text-right">
                <span>
                  {{ $t("Global.money") }}{{ requisition_out_price_total | formatTwoDot }}
                </span>
              </td>
              <td v-if="isView" class="align-end text-right">
                <span>
                  {{ $t("Global.money") }}{{ requisition_in_average_price | formatTwoDot }}
                </span>
              </td>
              <td v-if="isView" class="align-end text-right">
                <span>
                  {{ $t("Global.money") }}{{ requisition_in_price_total | formatTwoDot }}
                </span>
              </td>
              <td
                v-if="requisitionType == 2 && requisition.bargaining_type == 1"
                class="align-end text-right"
              ></td>
              <td v-if="savable" colspan="3"></td>
            </tr>
            <tr no-gutters class="d-table-row d-sm-none">
              <!-- <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{
                    $t("Requisition.DetailFields.order_num_count")
                  }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ order_num_count | formatTwoDot }}
                </div>
              </td> -->
              <td
                class="v-data-table__mobile-row"
                v-if="isView || mode == 'edit'"
              >
                <div class="v-data-table__mobile-row__header">
                  {{ $t("Requisition.DetailFields.requisition_num_count") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ requisition_num_count | formatTwoDot }}
                </div>
              </td>
            </tr>
          </template>
          <template v-slot:item.Description="{ item }">
            <a
                class="text-no-wrap"
                :class="item.error_flg ? 'red--text' : ''"
                @click.stop="
                dialogMaterialID = item.new
                  ? item.material.material_id
                  : item.material_id
              "
            >
              <span>
                {{ item.material_name }}
              </span>
              <br />
              <span class="caption secondary--text">
                {{ $t("Material.Fields.standard") }}{{ $t("Global.colon") }}
                <span
                    v-if="item.standard_name && item.standard_name.length > 12"
                    :title="item.standard_name"
                    style="cursor: pointer"
                >
                  {{ item.standard_name.slice(0, 12) + "......" }}
                </span>
                <span v-else>
                  {{ item.standard_name }}
                </span>
              </span>
            </a>
          </template>
          <template v-slot:item.unit="{ item }">
            <v-autocomplete
                v-if="savable && !isReturn"
                v-model="item.standard_detail_id"
                :items="item.standard.standard_details"
                item-text="unit"
                item-value="id"
                unclearable
                style="width: 20px"
            />
            <span v-else>
              {{ item.unit }}
            </span>
          </template>
          <template v-slot:item.order_num="{ item }">
            <ValidationProvider
                v-if="isNew"
                v-slot="{ errors }"
                :name="$t('Requisition.DetailFields.requisition_num')"
                rules="required"
            >
              <NumberInput
                  v-model="item.order_num"
                  :error-messages="errors"
                  class="ml-0"
                  dense
              />
            </ValidationProvider>
            <ValidationProvider
                v-else-if="isReturn"
                v-slot="{ errors }"
                :name="$t('Requisition.DetailFields.order_num')"
                :rules="{
                required: true,
                min_value: 0,
                max_value: item.refundable_num,
              }"
            >
              <NumberInput
                  v-model="item.order_num"
                  :error-messages="errors"
                  class="ml-0"
                  dense
              />
            </ValidationProvider>
            <span v-else> {{ item.order_num | formatTwoDot }} </span>
          </template>
          <template v-slot:item.requisition_price="{ item }">
            <ValidationProvider
                v-if="savable"
                v-slot="{ errors }"
                rules="trequired"
            >
              <v-text-field
                  v-model="item.requisition_price"
                  single-line
                  dense
                  type="number"
                  min="0"
                  :prefix="$t('Global.money')"
                  @blur="
                  item.requisition_price =
                    $numberFormatter.formatWithDotNoMoreThan(
                      item.requisition_price,
                      2
                    )
                "
                  style="max-width: 80px; margin-left: auto"
                  class="mb-n4"
                  :error-messages="errors"
              />
            </ValidationProvider>
            <span v-else>
              {{ $t("Global.money") }}
              {{ item.requisition_price | formatMoney }}
            </span>
          </template>
          <template v-slot:item.unit_price="{ item }">
            <ValidationProvider
              v-if="savable"
              v-slot="{ errors }"
              rules="trequired"
            >
              <v-text-field
                v-model="item.unit_price"
                single-line
                dense
                type="number"
                min="0"
                :prefix="$t('Global.money')"
                @blur="
                  item.unit_price =
                    $numberFormatter.formatWithDotNoMoreThan(
                      item.unit_price,
                      2
                    )
                "
                style="max-width: 80px; margin-left: auto"
                class="mb-n4"
                :error-messages="errors"
              />
            </ValidationProvider>
            <span v-else>
              {{ $t("Global.money") }}
              {{ item.unit_price | formatMoney }}
            </span>
          </template>
          <template v-slot:item.requisition_num="{ item }">
            <ValidationProvider
                v-if="savable"
                v-slot="{ errors }"
                :name="$t('Requisition.DetailFields.requisition_num')"
                rules="required"
            >
              <NumberInput
                  v-model="item.requisition_num"
                  :error-messages="errors"
                  dense
                  class="ml-0"
              />
            </ValidationProvider>
            <span v-else>
              {{ item.requisition_num | formatTwoDot }}
            </span>
          </template>
          <template v-slot:item.requisition_out_price="{ item }">
            <span>
              {{ $t("Global.money") }}
              {{ item.requisition_out_price | formatMoneyFloor }}
            </span>
          </template>
          <template v-slot:item.requisition_in_price="{ item }">
            <span>
              {{ $t("Global.money") }}
              {{ item.requisition_in_price | formatMoneyFloor }}
            </span>
          </template>
          <template v-slot:item.requisition_in_price_total="{ item }">
             <span>
              {{ $t("Global.money") }}
              {{ item.requisition_in_price_total | formatMoneyFloor }}
            </span>
          </template>
          <template v-slot:item.requisition_out_price_total="{ item }">
             <span>
              {{ $t("Global.money") }}
              {{ item.requisition_out_price_total | formatMoneyFloor }}
            </span>
          </template>
          <template v-slot:item.from_stock_material="{ item }">
            <span
                class="text-no-wrap caption secondary--text"
                :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ $t("Requisition.DetailFields.unrequisition") }}
              {{ $t("Global.colon") }}
              {{
                item.new
                    ? $numberFormatter.formatTwoDot(
                        item.from_stock_material,
                        true
                    )
                    : $numberFormatter.formatTwoDot(
                        item.from_stock_material.current_count,
                        true
                    )
              }}
            </span>
            <br />
            <span
                class="text-no-wrap caption secondary--text"
                :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ $t("Requisition.DetailFields.requisitioned") }}
              {{ $t("Global.colon") }}
              <span class="primary--text">
                {{
                  $numberFormatter.formatTwoDot(
                      item.from_stock_material_new,
                      true
                  )
                }}
              </span>
            </span>
          </template>
          <template v-slot:item.to_stock_material="{ item }">
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ $t("Requisition.DetailFields.unrequisition") }}
              {{ $t("Global.colon") }}
              {{
                item.new
                  ? $numberFormatter.formatTwoDot(item.to_stock_material, true)
                  : $numberFormatter.formatTwoDot(
                      item.to_stock_material.current_count,
                      true
                    )
              }}
            </span>
            <br />
            <span
                class="text-no-wrap caption secondary--text"
                :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ $t("Requisition.DetailFields.requisitioned") }}
              {{ $t("Global.colon") }}
              <span class="red--text">
                {{
                  $numberFormatter.formatTwoDot(
                      item.to_stock_material_new,
                      true
                  )
                }}
              </span>
            </span>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
                v-if="item.new"
                small
                text
                class="danger--text pa-0"
                @click.stop="
                requisition_details.splice(
                  requisition_details.findIndex((detail) =>
                    item.id ? item.id == detail.id : item.new == detail.new
                  ),
                  1
                )
              "
            >
              <v-icon>fa-times</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </ValidationObserver>
    </v-sheet>

    <MaterialDialog v-model="dialogMaterialID" />
    <RequisitionMaterialsSelectsDialog
      v-model="requisitionMaterialDialog"
      :requisitionMaterialItems="materialItems"
      @confirm="addMaterials = $event"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Required from "@/components/plugins/Required";
import Requisitions from "@/api/requisitions";
import SearcherStock from "@/components/plugins/SearcherStock";
import SearcherAccountUser from "@/components/plugins/SearcherAccountUser";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import MaterialDialog from "@/components/materials/plugins/Dialog";
import NumberInput from "@/components/plugins/NumberInput";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import RequisitionActions from "./plugins/Actions";
import RequisitionMaterialsSelectsDialog from "./plugins/RequisitionMaterialsSelectsDialog";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    Required,
    SearcherStock,
    SearcherAccountUser,
    SearcherDatetime,
    MaterialDialog,
    NumberInput,
    ValidationObserver,
    ValidationProvider,
    RequisitionActions,
    RequisitionMaterialsSelectsDialog,
  },
  computed: {
    stock_id() {
      return this.stockSelected ? this.stockSelected.id : null;
    },
    isView() {
      return !this.mode || this.mode == "view";
    },
    isReturn() {
      return this.mode == "return";
    },
    savable() {
      return !this.preview && (this.mode == "new" || this.mode == "edit" || this.mode == 'return');
    },
    isNew() {
      return this.mode == "new";
    },

    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.requisitions"),
          disabled: false,
          href: "/requisitions",
        },
        {
          text: this.isNew
              ? i18n.t("Nav.requisitionNew")
              : i18n.t("Nav.requisitionDetail"),
          disabled: true,
        },
      ];
      if (!this.isNew) {
        items.push({
          text:
              this.requisition && this.requisition.requisition_code
                  ? this.requisition.requisition_code
                  : "",
          disabled: false,
          accent: true,
        });
      }
      return items;
    },

    premiumModels() {
      return [
        {
          text: i18n.t("Requisition.DetailFields.manual_set"),
          value: 1,
        },
        {
          text: i18n.t("Requisition.DetailFields.up_stock_batch_cost"),
          value: 2,
        },
      ];
    },

    detailsHeaders() {
      var headers = [
        {
          text: i18n.t("Requisition.DetailFields.material_category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("Requisition.DetailFields.material_code"),
          align: "start",
          value: "material_code",
        },
        {
          text: i18n.t("Requisition.DetailFields.material_name"),
          align: "start",
          width: "500px",
          value: "Description",
        },
        {
          text: i18n.t("Requisition.DetailFields.unit"),
          align: "start",
          value: "unit",
        },
      ];
      if (this.isReturn){
        headers.push(
            {
              text: i18n.t("Requisition.DetailFields.refundable_num"),
              align: "end",
              value: "refundable_num",
            })
      }
      headers.push(
          {
            text: i18n.t("Requisition.DetailFields.order_num"),
            align: "end",
            value: "order_num",
            width: 160
          })
      if ((this.isView || this.mode == 'edit')) {
        headers.push({
          text: i18n.t("Requisition.DetailFields.requisition_num"),
          align: "end",
          value: "requisition_num",
        })
      }
      if (this.isShowUnitPrice) {
        headers.push(
          {
            text: i18n.t("Requisition.DetailFields.unit_price"),
            align: "end",
            value: "unit_price",
          })
      }
      if (this.isView) {
        headers.push(
            {
              text: i18n.t("Requisition.DetailFields.requisition_out_average_price"),
              align: "end",
              value: "requisition_out_price",
            },
            {
              text: i18n.t("Requisition.DetailFields.requisition_out_price_total"),
              align: "end",
              value: "requisition_out_price_total",
            },
            {
              text: i18n.t("Requisition.DetailFields.requisition_in_average_price"),
              align: "end",
              value: "requisition_in_price",
            },
            {
              text: i18n.t("Requisition.DetailFields.requisition_in_price_total"),
              align: "end",
              value: "requisition_in_price_total",
            },
        )
      }
      if (this.requisitionType == 2 && this.requisition.bargaining_type == 1) {
        headers.push({
          text: i18n.t("Requisition.DetailFields.requisition_price"),
          align: "start",
          value: "requisition_price",
        });
      }

      if (this.savable) {
        headers.push(
            {
              text: i18n.t(
                  "Requisition.DetailFields.stock_requisition_out_num_count"
              ),
              align: "end",
              value: "from_stock_material",
            },
            {
              text: i18n.t(
                  "Requisition.DetailFields.stock_requisition_in_num_count"
              ),
              align: "end",
              value: "to_stock_material",
            },
            {
              text: i18n.t("TableHeaders.actions"),
              align: "start",
              sortable: false,
              value: "actions",
            }
        );
      }

      return headers;
    },

    activitiesHeaders: () => [
      {
        text: i18n.t("Requisition.ActivityFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("Requisition.ActivityFields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("Requisition.ActivityFields.operater"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],
    relationsHeaders: () => [
      {
        text: i18n.t("Order.RelationFields.identify_name"),
        align: "center",
        sortable: false,
        value: "identify_name",
      },
      {
        text: i18n.t("Order.RelationFields.identify_code"),
        align: "center",
        sortable: false,
        value: "identify_code",
      },
      {
        text: i18n.t("Order.RelationFields.status"),
        align: "center",
        sortable: false,
        value: "status",
      },
      {
        text: i18n.t("Order.RelationFields.creater"),
        align: "start",
        sortable: false,
        value: "creater_name",
      },
      {
        text: i18n.t("Order.RelationFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
    ],

    materialItems() {
      return this.materials.map((detail) => {
        let standard_name = detail.new ? detail.material.standard_name : detail.standard_name
        detail.Description = i18n.t(
            this.settings
                ? this.settings.material_name_display_type == 4
                    ? "Material.nameWithCodeAndStandard"
                    : this.settings.material_name_display_type == 3
                    ? "Material.materialNameWithCodeAndStandard"
                    : this.settings.material_name_display_type == 2
                        ? "Material.materialNameWithCode"
                        : "Material.materialName"
                : "Material.materialName",
            [
              detail.material_code,
              detail.material_name,
              standard_name ? (standard_name.length > 12 ? standard_name.slice(0, 12) + "......" : standard_name) : ""
            ]
        );
        detail.disabled = this.materialDisabledItems
            ? this.materialDisabledItems.find((disabledItem) =>
                disabledItem.new
                    ? disabledItem.id == detail.id
                    : disabledItem.material_id
                        ? disabledItem.material_id == detail.id
                        : ""
            )
            : false;
        return detail;
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings", "accountUser"]),
  },

  data: () => ({
    panels: [0],
    tab: null,
    filter: "",
    mode: "",
    requisition: {},
    requisition_details: [],
    requisition_activities: [],
    stockOutSelected: null,
    stockInSelected: null,
    requisitionStockIds: { stock_from_id: 0, stock_to_id: 0 },
    stockOutDisabledArr: [],
    stockInDisabledArr: [],
    executeUserSelected: null,
    datetimeRage: [new Date()],
    standard_detail: null,
    addMaterial: null,
    materials: [],
    materialDisabledItems: [],
    materialLoading: false,
    materialSearch: "",
    dialogMaterialID: null,
    requisitionType: 1,
    requisitionMaterialDialog: false,
    addMaterials: [],
    order_num_count: 0,
    requisition_num_count: 0,
    requisition_out_price_total: 0,
    requisition_in_price_total: 0,
    requisition_out_average_price: 0,
    requisition_in_average_price: 0,
    relations: [],
    edit_express_price: false,
    isShowUnitPrice: false,
  }),

  mounted() {
    if (this.$route.path.startsWith("/requisitions/premuim-new")) {
      this.requisitionType = 2;
      this.mode = "new";
    } else if (this.$route.path.startsWith("/requisitions/new")) {
      this.requisitionType = 1;
      this.mode = "new";
    } else {
      this.mode = this.$route.params.mode;
      if (this.mode)
        this.$router.replace("/requisitions/" + this.$route.params.id);
    }
  },

  methods: {
    getRequisitionFromAPI() {
      Requisitions.fetchOne(this.$route.params.id, { order_activity: 1 }).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.requisition = response.data.requisition;
              this.requisitionType = response.data.requisition.type
                  ? response.data.requisition.type
                  : 1;
              this.requisition_details =
                  response.data.requisition.requisition_details;
              this.requisition_activities = response.data.order_activities;
              this.requisition_details.forEach((detail) => {
                this.order_num_count += Number(detail.order_num);
                this.requisition_num_count += Number(detail.requisition_num);
                this.requisition_out_price_total += Number(detail.requisition_out_price_total);
                this.requisition_in_price_total += Number(detail.requisition_in_price_total);
                this.requisition_out_average_price += Number(detail.requisition_out_price);
                this.requisition_in_average_price += Number(detail.requisition_in_price);
              });
              this.relations = [];
              if ((this.requisition.to_stock.identity_type == 1 || this.requisition.to_stock.identity_type == 2) // 调入仓库必须要自有仓或三方仓
                  && (this.requisition.from_stock.identity_type == 1 || this.requisition.from_stock.identity_type == 2) // 调出仓库必须要自有仓或三方仓
                  && (this.requisition.to_stock.identity_type != this.requisition.from_stock.identity_type)) {
                this.isShowUnitPrice = true;
              }
              if (this.requisition.status == 1) {
                this.relations = [];
                // 当调拨单状态为待确认时检测是否需要显示调拨价格
              } else if (this.requisition.status == 2) {
                this.relations.push(
                    Object.assign(
                        {
                          controller: "StockOuts",
                          identify_name: i18n.t("StockOrderOUT.ObjectName"),
                          identify_code:
                          response.data.requisition.from_stock_order
                              .stock_order_code,
                        },
                        response.data.requisition.from_stock_order
                    )
                );
              } else {
                this.relations.push(
                    Object.assign(
                        {
                          controller: "StockOuts",
                          identify_name: i18n.t("StockOrderOUT.ObjectName"),
                          identify_code:
                          response.data.requisition.from_stock_order
                              .stock_order_code,
                        },
                        response.data.requisition.from_stock_order
                    ),
                    Object.assign(
                        {
                          controller: "StockIns",
                          identify_name: i18n.t("StockOrderIN.ObjectName"),
                          identify_code:
                          response.data.requisition.to_stock_order.stock_order_code,
                        },
                        response.data.requisition.to_stock_order
                    )
                );
              }
              if (this.requisition.type == 3) {
                this.relations.push(
                    Object.assign(
                        {
                          controller: "Requisitions",
                          identify_name: i18n.t("Requisition.ObjectName"),
                          identify_code:
                          response.data.requisition.parent_requisition
                              .requisition_code,
                        },
                        response.data.requisition.parent_requisition
                    )
                );
              }
              if (this.requisition.type == 4 || this.requisition.type == 5 || this.requisition.type == 6 || this.requisition.type == 7) {
                this.relations.push(
                  Object.assign(
                    {
                      controller: "Receipt",
                      identify_name: i18n.t("Bill.ObjectName"),
                      identify_code:
                      response.data.requisition.bill.bill_code,
                    },
                      response.data.requisition.bill
                  )
                );
              }
            }
          }.bind(this)
      );
    },
    getReturnableListFromAPI() {
      Requisitions.getReturnableList(this.$route.params.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.requisition = {
                requisition_code: response.data.requisition.requisition_code,
                parent_id: response.data.requisition.id,
                actual_date: this.$datetimeUtils.formatTime(new Date()),
                type: 3,
                requisition_details: [],
                detail_length: 0
              }
              if ((response.data.requisition.to_stock.identity_type == 1 || response.data.requisition.to_stock.identity_type == 2) // 调入仓库必须要自有仓或三方仓
                  && (response.data.requisition.from_stock.identity_type == 1 || response.data.requisition.from_stock.identity_type == 2) // 调出仓库必须要自有仓或三方仓
                  && (response.data.requisition.to_stock.identity_type != response.data.requisition.from_stock.identity_type)) {
                this.isShowUnitPrice = true;
              }
              this.requisition_details = response.data.requisition.requisition_details
              this.requisition_details.forEach((detail) => {
                detail.order_num = 0
                this.order_num_count += Number(detail.order_num);
                this.requisition_num_count += Number(detail.requisition_num);
                this.requisition_out_price_total += Number(detail.requisition_out_price_total);
                this.requisition_in_price_total += Number(detail.requisition_in_price_total);
                this.requisition_out_average_price += Number(detail.requisition_out_price);
                this.requisition_in_average_price += Number(detail.requisition_in_price);
              });

            }
          }.bind(this)
      )
    },

    doSubmit() {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
          function (result) {
            if (result) {
              if (this.mode == "new") {
                var submitNewData = {
                  requisition_from: this.requisitionStockIds.stock_from_id,
                  requisition_to: this.requisitionStockIds.stock_to_id,
                  actual_date: this.requisition.actual_date,
                  operate_user_id: this.executeUserSelected.id,
                  bargaining_type: this.requisition.bargaining_type,
                  memo: this.requisition.memo,
                  type: this.requisitionType,
                  requisition_details: [],
                };
                if (
                    this.settings &&
                    this.settings.requisition_express_price == 1
                ) {
                  submitNewData = Object.assign({}, submitNewData, {
                    express_price: this.requisition.express_price,
                  });
                }
                if (
                    this.requisitionType == 2 &&
                    this.requisition.bargaining_type == 2
                ) {
                  submitNewData = Object.assign({}, submitNewData, {
                    cost_float_rate: this.requisition.cost_float_rate,
                  });
                }
                this.requisition_details.forEach((d) => {
                  let detail = {
                    material_code: d.material_code,
                    standard_detail_id: d.standard_detail_id,
                    order_num: d.order_num,
                    // d.rate > 1 ? d.order_num * d.rate : d.order_num,
                  };
                  if (
                      this.requisitionType == 2 &&
                      this.requisition.bargaining_type == 1
                  ) {
                    detail = Object.assign({}, detail, {
                      requisition_price: d.requisition_price,
                    });
                  }
                  if (this.isShowUnitPrice) {
                    detail = Object.assign({}, detail, {
                      unit_price: d.unit_price,
                    });
                  }
                  submitNewData.requisition_details.push(detail);
                });
                Requisitions.add(submitNewData)
                    .then(
                        function (response) {
                          if (response.data.status.isOK()) {
                            this.$refs.observer.reset();
                            this.$router.push("/requisitions");
                          }
                          this.$store.dispatch("fullscreenLoadingStop");
                        }.bind(this)
                    )
                    .catch(
                        function () {
                          this.$store.dispatch("fullscreenLoadingStop");
                        }.bind(this)
                    );
              }
              if (this.mode == "return") {
                let submitReturnData = {
                  parent_id: this.requisition.parent_id,
                  actual_date: this.requisition.actual_date,
                  operate_user_id: this.executeUserSelected.id,
                  type: 3,
                  memo: this.requisition.memo,
                  requisition_details: [],
                };
                if (
                    this.settings &&
                    this.settings.requisition_express_price == 1
                ) {
                  submitReturnData = Object.assign({}, submitReturnData, {
                    express_price: this.requisition.express_price,
                  });
                }
                this.requisition_details.forEach((d) => {
                  let detail = {
                    material_code: d.material_code,
                    standard_detail_id: d.standard_detail_id,
                    order_num: d.order_num,
                  };
                  submitReturnData.requisition_details.push(detail);
                });
                Requisitions.returnSave(submitReturnData)
                    .then(
                        function (response) {
                          if (response.data.status.isOK()) {
                            this.$refs.observer.reset();
                            this.$router.push("/requisitions");
                          }
                          this.$store.dispatch("fullscreenLoadingStop");
                        }.bind(this)
                    ).catch(
                    function () {
                      this.$store.dispatch("fullscreenLoadingStop");
                    }.bind(this)
                );
              }
              if (this.mode == "edit") {
                var submitEditData = {
                  id: this.requisition.id,
                  actual_date: this.requisition.actual_date,
                  operate_user_id: this.requisition.operate_user_id,
                  bargaining_type: this.requisition.bargaining_type,
                  requisition_details: [],
                  memo: this.requisition.memo,
                };
                if (
                    this.settings &&
                    this.settings.requisition_express_price == 1
                ) {
                  submitEditData = Object.assign({}, submitEditData, {
                    express_price: this.requisition.express_price,
                  });
                }
                if (
                    this.requisitionType == 2 &&
                    this.requisition.bargaining_type == 2
                ) {
                  submitEditData = Object.assign({}, submitEditData, {
                    cost_float_rate: this.requisition.cost_float_rate,
                  });
                }
                this.requisition_details.forEach((d) => {
                  let detail = {};
                  if (d.new) {
                    detail = {
                      material_code: d.material_code,
                      standard_detail_id: d.standard_detail_id,
                      requisition_num: d.requisition_num,
                      // d.rate > 1
                      //   ? d.requisition_num * d.rate
                      //   : d.requisition_num,
                    };
                    if (
                        this.requisitionType == 2 &&
                        this.requisition.bargaining_type == 1
                    ) {
                      detail = Object.assign({}, detail, {
                        requisition_price: d.requisition_price,
                      });
                    }
                    submitEditData.requisition_details.push(detail);
                  } else {
                    detail = {
                      id: d.id,
                      standard_detail_id: d.standard_detail_id,
                      requisition_num: d.requisition_num,
                      // d.rate > 1
                      //   ? d.requisition_num * d.rate
                      //   : d.requisition_num,
                    };
                    if (
                        this.requisitionType == 2 &&
                        this.requisition.bargaining_type == 1
                    ) {
                      detail = Object.assign({}, detail, {
                        requisition_price: d.requisition_price,
                      });
                    }
                    if (this.isShowUnitPrice) {
                      detail = Object.assign({}, detail, {
                        unit_price: d.unit_price,
                      });
                    }
                    submitEditData.requisition_details.push(detail);
                  }
                });

                Requisitions.edit(submitEditData)
                    .then(
                        function (response) {
                          if (response.data.status.isOK()) {
                            this.$refs.observer.reset();
                            this.$router.push("/requisitions");
                          }
                          this.$store.dispatch("fullscreenLoadingStop");
                        }.bind(this)
                    )
                    .catch(
                        function () {
                          this.$store.dispatch("fullscreenLoadingStop");
                        }.bind(this)
                    );
              }
            } else {
              this.$store.dispatch("fullscreenLoadingStop");
            }
          }.bind(this)
      );
    },
    saveExpressPrice() {
      this.$store.dispatch("fullscreenLoading");
      Requisitions.editExpressPrice({
        id: this.$route.params.id,
        express_price: this.requisition.express_price,
      })
          .then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.edit_express_price = false;
                  this.$snackbar.success(
                      i18n.t("Order.messages.editExpressPriceSuccess")
                  );
                  this.getRequisitionFromAPI();
                  this.$store.dispatch("fullscreenLoadingStop");
                }
              }.bind(this)
          )
          .catch(
              function () {
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
          );
    },
  },

  watch: {
    mode: {
      handler() {
        if (this.isNew) {
          this.requisition = {
            actual_date: this.$datetimeUtils.formatTime(new Date()),
            bargaining_type: 2,
            requisition_details: [],
            // type: 1,
            detail_length: 0,
          };
        } else if (this.isReturn) {
          this.getReturnableListFromAPI();
        } else if (this.$route.params.id) {
          this.getRequisitionFromAPI();
        }
      },
    },
    accountUser: {
      handler() {
        this.executeUserSelected = this.accountUser ? this.accountUser : null;
      },
    },
    stockOutSelected: {
      handler() {
        this.stockInDisabledArr = [];
        if (this.stockOutSelected && this.stockOutSelected.id) {
          this.requisitionStockIds.stock_from_id = this.stockOutSelected.id;
          this.stockInDisabledArr.push(this.stockOutSelected);
        } else {
          this.requisitionStockIds.stock_from_id = 0;
          this.requisition.type = '';
        }
      },
    },
    stockInSelected: {
      handler() {
        this.stockOutDisabledArr = [];
        if (this.stockInSelected && this.stockInSelected.id) {
          this.requisitionStockIds.stock_to_id = this.stockInSelected.id;
          this.stockOutDisabledArr.push(this.stockInSelected);
        } else {
          this.requisitionStockIds.stock_to_id = 0;
          this.requisition.type = '';
        }
      },
    },
    requisitionStockIds: {
      deep: true,
      handler() {
        //切换调入、调出仓库时，清空添加的调拨商品
        if (this.requisition_details.length) {
          for (let key = this.requisition_details.length - 1; key >= 0; key--) {
            if (this.requisition_details[key].new) {
              this.requisition_details.splice(key, 1);
            }
          }
        }
        if (
            this.requisitionStockIds.stock_from_id &&
            this.requisitionStockIds.stock_to_id
        ) {
          //切换调入、调出仓库时，重新获取调拨商品列表
          this.materialLoading = true;
          Requisitions.requisitionStockMaterials(this.requisitionStockIds)
              .then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.materials = response.data.stock_materials;
                    }
                    this.materialLoading = false;
                  }.bind(this)
              )
              .catch(
                  function () {
                    this.materialLoading = false;
                  }.bind(this)
              );
          if ((this.isNew && this.stockOutSelected && this.stockOutSelected.id && this.stockInSelected && this.stockInSelected.id // 调拨价格 先选择对应调入调出仓库
              && (this.stockOutSelected.identity_type == 1 || this.stockOutSelected.identity_type == 2) // 调入仓库必须要自有仓或三方仓
              && (this.stockInSelected.identity_type == 1 || this.stockInSelected.identity_type == 2) // 调出仓库必须要自有仓或三方仓
              && (this.stockOutSelected.identity_type != this.stockInSelected.identity_type))) {
            if (this.stockOutSelected.identity_type == 1 && this.stockInSelected.identity_type == 2 && this.isNew) {
              this.requisition.type = 4
            }
            if (this.stockOutSelected.identity_type == 2 && this.stockInSelected.identity_type == 1 && this.isNew) {
              this.requisition.type = 6
            }
            this.isShowUnitPrice = true;
          }else {
            // 普通调拨
            if (this.isNew) {
              this.requisition.type = 1
              this.isShowUnitPrice = false;
            }

          }
        } else {
          this.materials = [];
        }
      },
    },
    requisition: {
      handler() {
        if (this.requisition && this.requisition.id) {
          this.requisitionStockIds.stock_from_id = this.requisition
              .from_stock_order
              ? this.requisition.from_stock_order.stock_id
              : 0;
          this.requisitionStockIds.stock_to_id = this.requisition.to_stock_order
              ? this.requisition.to_stock_order.stock_id
              : 0;
        }
      },
    },
    requisition_details: {
      deep: true,
      handler() {
        //计算调拨后的数量
        if (this.requisition_details.length) {
          var order_num_count = 0;
          var requisition_num_count = 0;
          this.requisition_details.forEach((detail) => {
            if (detail.id) {
              this.materialDisabledItems.push(detail);
            }
            if (!detail.from_stock_material_new && !detail.new) {
              detail.from_stock_material_new = JSON.parse(
                  JSON.stringify(detail.from_stock_material.current_count)
              );
              detail.to_stock_material_new = JSON.parse(
                  JSON.stringify(detail.to_stock_material.current_count)
              );
            }
            //换算调拨量
            var standard_detail = detail.standard.standard_details.find(
                (standard) => standard.id == detail.standard_detail_id
            );
            var requisitionNum = 0;
            if (standard_detail) {
              requisitionNum = detail.requisition_num * standard_detail.rate;
              detail.rate = standard_detail.rate;
            }
            if (detail.new) {
              if (
                  requisitionNum + detail.from_stock_material_new >
                  detail.from_stock_material ||
                  requisitionNum + detail.from_stock_material_new <
                  detail.from_stock_material
              ) {
                detail.from_stock_material_new =
                    detail.from_stock_material - requisitionNum;
                detail.to_stock_material_new =
                    detail.to_stock_material + requisitionNum;
              }
            } else {
              if (
                  requisitionNum + detail.from_stock_material_new >
                  detail.from_stock_material.current_count ||
                  requisitionNum + detail.from_stock_material_new <
                  detail.from_stock_material.current_count
              ) {
                detail.from_stock_material_new =
                    detail.from_stock_material.current_count - requisitionNum;
                detail.to_stock_material_new =
                    detail.to_stock_material.current_count + requisitionNum;
              }
            }
            order_num_count += Number(detail.order_num);
            requisition_num_count += Number(detail.requisition_num);
          });
          this.order_num_count = order_num_count;
          this.requisition_num_count = requisition_num_count;
        }
      },
    },
    addMaterial: {
      handler() {
        if (this.addMaterial && this.addMaterial.id) {
          this.materialDisabledItems.push(this.addMaterial);
          //获取基准单位
          var default_unit = this.addMaterial.standard.standard_details.find(
              (standard_detail) => standard_detail.default_flg == 1
          );

          this.requisition_details.push({
            new: this.requisition_details.length + 1,
            category_name: this.addMaterial.material_category.name,
            material_name: this.addMaterial.material_name,
            material_code: this.addMaterial.material_code,
            standard_name: this.addMaterial.standard_name,
            standard: this.addMaterial.standard,
            from_stock_material: this.addMaterial.from_stock_material,
            from_stock_material_new: JSON.parse(
                JSON.stringify(this.addMaterial.from_stock_material)
            ),
            to_stock_material: this.addMaterial.to_stock_material,
            to_stock_material_new: JSON.parse(
                JSON.stringify(this.addMaterial.to_stock_material)
            ),
            standard_details: this.addMaterial.standard.standard_details,
            standard_detail_id: default_unit.id,
            requisition_num: "",
            requisition_price: this.addMaterial.supply_price,
            unit_price: this.isShowUnitPrice ? this.addMaterial.template_price ? this.addMaterial.template_price : 0 : null,
          });

          this.addMaterial = {};
        }
      },
    },
    addMaterials: {
      handler() {
        if (this.addMaterials && this.addMaterials.length) {
          this.addMaterials.forEach((addMaterial) => {
            if (addMaterial && addMaterial.id) {
              this.materialDisabledItems.push(addMaterial);
              //获取基准单位
              var default_unit = addMaterial.standard.standard_details.find(
                  (standard_detail) => standard_detail.default_flg == 1
              );

              this.requisition_details.push({
                new: this.requisition_details.length + 1,
                material_id: addMaterial.id,
                category_name: addMaterial.material_category.name,
                material_name: addMaterial.material_name,
                material_code: addMaterial.material_code,
                standard_name: addMaterial.standard_name,
                standard: addMaterial.standard,
                from_stock_material: addMaterial.from_stock_material,
                from_stock_material_new: JSON.parse(
                    JSON.stringify(addMaterial.from_stock_material)
                ),
                to_stock_material: addMaterial.to_stock_material,
                to_stock_material_new: JSON.parse(
                    JSON.stringify(addMaterial.to_stock_material)
                ),
                standard_details: addMaterial.standard.standard_details,
                standard_detail_id: default_unit.id,
                requisition_num: "",
                requisition_price: addMaterial.supply_price,
                unit_price: this.isShowUnitPrice ? addMaterial.template_price ? addMaterial.template_price : 0 : null,
              });
            }
          });
          this.addMaterials = [];
        }
      },
    },
  },
};
</script>